/* Copyright (c) 2022 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum VideoPlayerStates {
    ADAPTATION,
    BUFFERING,
    DRM_CONFIGURED,
    END_OF_STREAM,
    ERROR_RECOVERY,
    FATAL_ERROR,
    FIRST_FRAME,
    INITIATION,
    LOADED,
    LOADING,
    MANIFEST_PARSED,
    NONE,
    PAUSE,
    PLAYING,
    RATE_CHANGE,
    READY,
    STALLED,
    TIME_UPDATE,
    UNLOADED,
}
